(function () {
  function playVideo(button) {
    if (button.disabled || button.dataset.wsVideoPlaying) return;

    var template = button.querySelector('[data-ws-video-template]');
    if (!template) return;

    button.dataset.wsVideoPlaying = 'true';

    var thumb = button.querySelector('.ws-video-gallery__thumb, .placeholder-svg');
    if (thumb) thumb.remove();
    var play = button.querySelector('.ws-video-gallery__play');
    if (play) play.remove();

    button.appendChild(template.content.cloneNode(true));
    var video = button.querySelector('video');
    if (video) video.play().catch(function () {});
  }

  function bind(button) {
    if (button.dataset.wsVideoBound) return;
    button.dataset.wsVideoBound = 'true';

    button.addEventListener('click', function () {
      playVideo(button);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ws-video-play]').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
